import { render } from "./SuccessfulSubmission.vue?vue&type=template&id=13936703&scoped=true"
import script from "./SuccessfulSubmission.vue?vue&type=script&lang=js"
export * from "./SuccessfulSubmission.vue?vue&type=script&lang=js"

import "./SuccessfulSubmission.vue?vue&type=style&index=0&id=13936703&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13936703"]])

export default __exports__